import { render, staticRenderFns } from "./DeliveryCard.vue?vue&type=template&id=023cdd52&scoped=true&lang=pug&"
import script from "./DeliveryCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCard.vue?vue&type=style&index=0&id=023cdd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023cdd52",
  null
  
)

export default component.exports